import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';

const init = () => ({
  type: USER.GET_ALL_DDI_INIT,
});

export const success = data => ({
  type: USER.GET_ALL_DDI_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.GET_ALL_DDI_FAILURE,
});

const getAllDdi = uuid => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getAllDdi(uuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getAllDdi;
